import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "inline"];
import { Tag } from 'foundations-components/transitional/components/Tag';
import RouterFilterButton from './RouterFilterButton';
// @ts-ignore untyped dependency
import { useEmbedContext } from '../../hooks/useEmbedContext';
import { jsx as _jsx } from "react/jsx-runtime";
export default function RouterFilterTagButton(_ref) {
  let {
      children,
      inline
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    isEmbedded
  } = useEmbedContext();
  const renderedTag = /*#__PURE__*/_jsx(Tag, {
    inline: inline,
    use: "default",
    children: children
  });
  if (isEmbedded) {
    return renderedTag;
  }
  return /*#__PURE__*/_jsx(RouterFilterButton, Object.assign({}, rest, {
    use: "unstyled",
    children: renderedTag
  }));
}